import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, TextField, Autocomplete } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

import {getAvailableProducts, getMultipleProducts} from '../services/products.js';
import { getAvailableItems } from '../services/item.js';
import {SnackBar} from  './general';

import moment from 'moment';
import { FormControl, InputLabel, Select, Chip, OutlinedInput, Box, MenuItem, FormHelperText } from '@mui/material'
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import { editBook, getBookingById } from '../services/booking.js';

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from '../actions/profile.js';

import dayjs from 'dayjs'


const classes = {
  body:{
    width:'100%',
    display:'flex',
    height: '100%'
  },
  dateCont: {
      display: 'flex',
      marginBottom: 10,
      flexDirection: 'column'
  },
  dateInd: {
      marginRight: 15
  },
  tenantCont: {
      display: 'flex',
      alignItems: 'center',
      marginBottom : 20
  },
  itemCont: {
    marginBottom : 20
  },
  left: {
      width: '55%'
  },
  right: {
    width: '50%',
    position: 'relative',
    height: 'calc(100% - 55px)',
    paddingBottom: '55px',
  },
  selItemCont: {
    display: 'flex',
    marginBottom:5,
    position: 'relative',
    minHeight:'80px'
  },
  selItemImg: {
    width: 100,
    objectFit:'contain'
  },
  selItemImgCont: {
    marginRight: 10,
    marginBottom: 5
  },
  selItemDetCont: {
    marginTop:5
  },
  selItemActionCont: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0
  },
  totalCont: {
    position:'absolute',
    bottom:0,
    width: '100%'
  },
  selTotCont: {
    display: 'flex',
    height: 50,
    alignItems:'center',
  },
  totalEl: {
    marginRight: 10,
    color: 'black',
    width:'100px'
  },
  dialoge: {
    height:'100%',
    maxHeight: '500px'
}, 
};

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}



const DateBar = ({fromDate, toDate, diff, billableDates}) => {
    
    return (
        <div style={classes.dateCont}>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10}}>
              <div style={classes.dateInd}>
                  <CalendarTodayIcon/>
              </div>
              <div style={classes.dateInd}>
                {moment(fromDate).format('DD-MM-YYYY HH:mm')}
              </div>
              <div style={classes.dateInd}> to </div>
              <div style={classes.dateInd}>
                  {moment(toDate).format('DD-MM-YYYY HH:mm')}
              </div>
            </div>
            <div>

              <Typography variant="caption" display="block" gutterBottom component="div">Booked Dates : {diff}</Typography>
              <Typography variant="caption" display="block" gutterBottom component="div">Billabe Days : {billableDates.length}</Typography>
            </div>
      </div>
    )
}

const Tenant = ({tenant={}}) => {
    
    return (
        <div style={classes.tenantCont}>
            <div style={classes.dateInd}><PersonIcon/></div>
            <div>{tenant.name}</div>
        </div>
      );
}

const ItemSelect = ({fromDate, toDate, items, displayItem, setDisplayItem, setSelectedItems, selectedItems, existingItems=[]}) => {
    const _existingItems =  Object.values( existingItems.reduce((acc, item) => {
      if (!acc[item.product]) {
        acc[item.product] = {...item, count: 0}
      }
      acc[item.product].count += 1
      return acc
    }, {}))

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSelect = async (event, value, reason) => {
        if (value) {
            const alreadyBooked = _existingItems.find(item => item.product === value._id)
            const index = selectedItems.findIndex(selItem =>selItem.id === value._id)
            value.count = alreadyBooked ? alreadyBooked.count : 1;
            if (index < 0) {
              //Make sure it is not the same item booked in this booking, deleted from frontend while editing
              if (!value.availableItems) {
                try {
                  value.availableItems = await getAvailableItems(dayjs(fromDate).format('YYYY-MM-DD HH:mm'), dayjs(toDate).format('YYYY-MM-DD HH:mm'), value._id)
                  value.availableItems = value.availableItems.map(_ => ({..._, rent: value.rent}))                
                  if (alreadyBooked) {
                      value.availableItems.push(alreadyBooked)
                      value.items = [alreadyBooked]
                  } else {
                      value.items = [value.availableItems[0]]
                  }
                } catch (e) {
                  if (e.status === 401) {
                      dispatch(removeUserAction())
                      navigate('/');
                  }
                }
              }
                const _selectedItems = [...selectedItems, value]
                setSelectedItems(_selectedItems)
            }
            setDisplayItem({name: ''})
        }
    }
    
    return (
        <div style={classes.itemCont}>
            <Autocomplete
            disablePortal
            ListboxProps={{
              style: {
              maxHeight:'200px'
              }
            }}
            getOptionLabel={option => option.name}
            id="combo-box-item"
            clearIcon={null}
            value={displayItem}
            onInputChange={(event, value, reason)=>{setDisplayItem({name: value})}}
            onChange={handleSelect}
            options={items}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Item" />}
            />
        </div>
      );
}

const SKUSelect = ({SKUs, selectedSKUs, onSkuSelect, count, itemCountMatch, setItemCountMatch}) => {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(undefined)
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        disablePortal: true,
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            }
        },
    };
    
    return SKUs &&(
        <FormControl sx={{ m: 1, width: 300 }} size="small">
            <InputLabel id="sku-select">SKU</InputLabel>
            <Select
                labelId="sku-select"
                id="sku-select"
                multiple
                disabled={SKUs.length === count && count === selectedSKUs.length}
                value={selectedSKUs.map(sku => sku.sku)}
                error={!itemCountMatch}
                onClose={()=>{
                    if(selectedSKUs.length < count || selectedSKUs.length > count) {
                        setItemCountMatch(false)                        
                    } else {
                        setItemCountMatch(true)
                    }
                }}
                 onBlur={()=>{
                    if(selectedSKUs.length < count || selectedSKUs.length > count) {
                        setItemCountMatch(false)                        
                    } else {
                        setItemCountMatch(true)
                    }
                }}
                onChange={onSkuSelect}
                input={<OutlinedInput id="sku-chip" label="SKU" />}
                renderValue={(selected) => {
                    return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => {
                            const _val = selectedSKUs.find(sel => sel.sku === value)
                            return(
                                <Chip key={_val.sku} label={_val.sku} onClick={(e)=>{e.stopPropagation();}}/>
                            )
                        })}
                    </Box>
                    )
                
                }
            }
                MenuProps={MenuProps}
            >
                {SKUs.map((item) => (
                    <MenuItem
                        key={item.sku}
                        value={item.sku}
                    >
                        {item.sku}
                    </MenuItem>
                ))}
            </Select>
            {!itemCountMatch && <FormHelperText sx={{color: 'error.main'}}>Please add at least {count} item(s)</FormHelperText>}
        </FormControl>
    )
}

const SelectedItemsCard = ({existingProducts, product, selectedItems, setSelectedItems, itemCountMatch, setItemCountMatch, refillAllItemsOnSelectedItemDelete}) => {
  const handleRemove = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem.id === id)
        if (index > -1) {
          const _selectedItems = [...selectedItems];
          refillAllItemsOnSelectedItemDelete(_selectedItems[index])
          _selectedItems.splice(index,1);
          setSelectedItems(_selectedItems)
        }
      }
    }
    const increment = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem.id === id)        
        if (index > -1 && selectedItems[index].count < selectedItems[index].availableItemsCount) {
          const _selectedItems = [...selectedItems];
          _selectedItems[index].count += 1
          setSelectedItems(_selectedItems)
        }
      }
    }
    const decrement = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem.id === id)
        if (index > -1 && selectedItems[index].count > 1) {
          const _selectedItems = [...selectedItems];
          _selectedItems[index].count -= 1
          setSelectedItems(_selectedItems)
        }
      }
    }

    const onSkuSelect = (id) => {
        return (e, child) => {
            const index = selectedItems.findIndex(selItem => selItem.id === id)
            const transformed = e.target.value.map(val => product.availableItems.find(prd => prd.sku === val))
            if (index > -1 && e.target.value.length <= selectedItems[index].count) {            
                const _selectedItems = [...selectedItems];
                _selectedItems[index].items = transformed
                setSelectedItems(_selectedItems)
            }
        }
    }
    
    //const productDetail = existingProducts.find(x=>x._id === product.id);
    let rent, availableItemsCount;
    if (product.rent) {
        rent = product.rent
    } else {
        //rent = productDetail.rent
    }
    if (product.availableItemsCount) { 
        availableItemsCount = product.availableItemsCount
    } else {
        //availableItemsCount = productDetail.availableItemsCount
    }
  return(
    <Card sx={classes.selItemCont}>
      <div style={classes.selItemImgCont}><img style={classes.selItemImg} src={product.image.thumb}/></div>
      <div style={classes.selItemDetCont}>
        <Typography variant="subtitle2" gutterBottom component="div">{product.name}</Typography>
        <Typography variant="caption" display="block" gutterBottom component="div">₹ {rent} /-</Typography>
        <SKUSelect
            itemCountMatch={itemCountMatch}
            setItemCountMatch={setItemCountMatch}
            SKUs={product.availableItems}
            selectedSKUs={product.items || []}
            //selectedSKUs={selectedItems || []}
            onSkuSelect={onSkuSelect(product.id)}
            count={product.count}
        />
      </div>
      <div style={classes.selItemActionCont}>
        <div><IconButton disabled={product.count === 1} onClick={decrement(product.id)}><RemoveIcon/></IconButton></div>
        <div>{product.count}</div>
        <div><IconButton disabled={product.count === availableItemsCount} onClick={increment(product.id)}><AddIcon/></IconButton></div>
        <div><IconButton  onClick={handleRemove(product.id)}><DeleteIcon/></IconButton></div>
      </div>
    </Card>
  )
}

const TotalCard = ({selectedItems=[], advance, existingProducts, numberofDays, setAmount, discount, setDiscount}) => {
  const [total, setTotal] = useState(0);
  
  useEffect(()=>{
    setAmount(total-discount);
  },[discount, total])

  useEffect(()=>{
    const _total = selectedItems.reduce((acc, item)=>{
            let rent;
            /*if(item.rent) {
                rent = parseInt(item.rent, 10)
            } else {
                const prodDetail = existingProducts.find(x=>x._id === item.id);
                rent = parseInt(prodDetail.rent, 10)
            }*/
            rent = item.rent || 0;
            return acc+(rent * numberofDays*item.count)
    }, 0)
    setTotal(_total)
  },[selectedItems, numberofDays])

  if (Array.isArray(selectedItems) && selectedItems.length > 0) {
    return (
      <Card sx={classes.selTotCont}>
        <div style={classes.totalEl}><TextField variant='standard' sx={classes.totalEl} disabled={true} label="Gross Total" value={`₹ ${total}/-`} /></div>
        <div style={classes.totalEl}> <TextField variant='standard' sx={classes.totalEl} value={discount} onChange={(e)=>{setDiscount(e.target.value)}}  label="Discount (₹)" /></div>
        <div style={classes.totalEl}> <TextField variant='standard' sx={classes.totalEl} value={advance} disabled={true} label="Advance (₹)" /></div>
        <div style={classes.totalEl}><TextField variant='standard' sx={classes.totalEl} disabled={true} label="Net Total" value={`₹ ${total - discount}/-`} /></div>
      </Card>
    )
  }
  return null;
}

export default function CustomizedDialogs(props) {
    const [editLoad, setEditLoad] = useState(false);
    const [bookData, setBookData] = useState(undefined);
    const [selectedItems, setSelectedItems] = useState([]);
    const [displayItem, setDisplayItem] = useState({name:''});
    const [existingProducts, setExistingProducts] = useState([])
    const [items, setItems] = useState([])
    const [numberofDays, setNumberofDays] = useState(1)
    //const [note, setNote] = useState('');
    const [amount, setAmount] = useState(0)
    const [discount, setDiscount] = useState(0);
    //const [advance, setAdvance] = useState(0);
    const [snackMessage, setSnackMessage] = useState('');
    const [snackType, setSnackType]= useState('error');
    const [showSnack, setShowSnack]= useState(false);
    const [itemCountMatch, setItemCountMatch] = useState(true)
    const isMobile = getWindowDimensions().width < 500 ? true : false;
    

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fillAvailableItemsAndCount = async ( bookData) => {
        if (Array.isArray(bookData.products) && bookData.products.length > 0) {
            const selectedItemsPromises = bookData.products.map(async (product) => {
                const alreadyBookedItems = bookData.items.filter(item => item.product === product.id)
                try {
                    let availableItems = await getAvailableItems(dayjs(bookData.from).format('YYYY-MM-DD HH:mm'), dayjs(bookData.to).format('YYYY-MM-DD HH:mm'), product.id)
                    // merge already booked item
                    availableItems = availableItems.concat(alreadyBookedItems)
                    // get unique items
                    availableItems = [...new Map(availableItems.map(obj => [obj.sku, obj])).values()]
                    
                    return {... product, availableItemsCount: availableItems.length , availableItems: availableItems.map(it => ({...it, rent: product.rent}))}
                } catch (e) {
                  if (e.status === 401) {
                      dispatch(removeUserAction())
                      navigate('/');
                  }
                    console.log(e)
                    return { ...product, availableItems: null };
                }
            })
            
            return await Promise.all(selectedItemsPromises)
        }
    }

    React.useEffect(()=>{
      if (props.id) {
          const getBookingData  = async(id) => {
            try {
              const data =  await getBookingById(id);
              //const existingProdIds = data.products.map(x=>x.id)
              //const existingProds = await getMultipleProducts(existingProdIds)
              //setExistingProducts(existingProds)
              //setFields(data);
              setDiscount(data.discount)
              setBookData(data);
            } catch (e) {
              if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
              }
            }
          }
          getBookingData(props.id)          
      }
    }, [props.id])

    useEffect(()=>{
          const getData = async() => {
            if (moment(bookData.to).startOf('day').isSameOrAfter(moment(bookData.from).startOf('day'))) {
                setNumberofDays(moment(bookData.to).startOf('day').diff(moment(bookData.from).startOf('day'), 'days')+1)
                try {
                  const data = await getAvailableProducts(moment(bookData.from).format('MM-DD-YYYY HH:mm'), moment(bookData.to).format('MM-DD-YYYY HH:mm'));                
                  const _selectedItems = await fillAvailableItemsAndCount(bookData)
                  setItems(data)
                  setSelectedItems(_selectedItems)
                } catch (e) {
                  if (e.status === 401) {
                      dispatch(removeUserAction())
                      navigate('/');
                  }
                }
            }
        }
        if (bookData?.to && bookData.from) {
          getData()
        }
    }, [bookData])

    const resetFields = () => {      
      //setAdvance(0);
      setDiscount(0);
    }

    const handleAddBookingClose = (e) => {
        props.setShowEditBooking(false);
        props.setEditableBooking(undefined);
        resetFields()
    }
    const validateItemsCount = (products) => {
      const misMatch = products.find(prd => prd.items.length !== prd.count)
      if (misMatch) {
        return misMatch
      }
      return ;
    }
    const handleClick =()=> {
        return async (e) => {
          if (Array.isArray(selectedItems) && selectedItems.length > 0 ) {
            const misMatch = validateItemsCount(selectedItems)
            if (!misMatch) {
              const data = {
                products: selectedItems.map(item=>{return{id: item._id || item.id, count: item.count, items: item.items}}),
                amount:amount,
                discount:discount,
              }
              try {
                setEditLoad(true)
                const resp = await editBook(props.id, data)
                props.setBookingEdited()
                //setSnackMessage('Edited booking')
                //setSnackType('success')
                //setShowSnack(true)
                handleAddBookingClose();
              } catch (e) {
                if (e.status === 401) {
                  dispatch(removeUserAction())
                  navigate('/');
                }
                setEditLoad(false)
                console.log(e)
                setSnackMessage('Could not edit book')
                setSnackType('error')
                setShowSnack(true)
              }
            } else {
              setSnackMessage(`Mismatch count for ${misMatch.name} `)
              setSnackType('error')
              setShowSnack(true)
            }
          } else {
            setSnackMessage('Please select at least one item')
            setSnackType('error')
            setShowSnack(true)
          }
        }
    }
    const refillAllItemsOnSelectedItemDelete =  (deletedItem) => {
      const hadBooked = bookData.items.find(item => item.product === deletedItem.id)
      const isAlreadyInItemsIndex = items.findIndex(item => item._id === deletedItem.id)      
      if (hadBooked) {
        if (isAlreadyInItemsIndex > -1) {
            const _items = [...items];
            // pick available items from the selected item array
            const _selectedItems = [...selectedItems];
            const delItemFromSelected = _selectedItems.find(prd => prd.id === deletedItem.id)
            _items[isAlreadyInItemsIndex].availableItemsCount += deletedItem.count
            _items[isAlreadyInItemsIndex].availableItems = delItemFromSelected.availableItems

        } else {
            const _items = [...items];
            _items.push({...deletedItem, _id: deletedItem.id})
            setItems(_items)
        }
      }
    }
    const diffTitle = numberofDays > 1 ? 'days' : 'day';
    let dayName ='';

    for (var m = moment(bookData?.from); m.diff(bookData?.to, 'days') <= 0; m.add(1, 'days')) {
      dayName += m.format('ddd') + ', ';
    }
    dayName = dayName.slice(0, -2); 
    
    if (props.open && bookData) {
    return (
      <div>
        <Dialog classes={{ paper: classes.dialoge}} onClose={handleAddBookingClose} fullWidth={true}
          maxWidth={"md"} aria-labelledby="customized-dialog-title" open={props.open}
          PaperProps={{sx:{height: '600px'}}}
          >
          <DialogTitle id="customized-dialog-title" onClose={handleAddBookingClose}>
            Edit Booking
          </DialogTitle>
          <DialogContent dividers style={{height: '100%'}}>
              <Container sx={classes.body} style={isMobile ? {flexDirection:'column'} : {}}>
                  <div  style={isMobile ? {...classes.left, width:'100%'} : classes.left}>
                      <DateBar fromDate={bookData.from} toDate={bookData.to} diff={` ${numberofDays} ${diffTitle} (${dayName})`} billableDates={bookData.billableDates}/>
                      <Tenant tenant={bookData.tenant}/>
                      <div style={classes.tenantCont}><div style={classes.dateInd}><TextSnippetIcon/></div> <div>{bookData?.notes?.bookingNotes || 'No Booking Notes'}</div></div>
                      <ItemSelect
                        fromDate={bookData.from}
                        existingItems={bookData.items}
                        toDate={bookData.to}
                        items={items}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        displayItem={displayItem}
                        setDisplayItem={setDisplayItem}
                      />
                  </div>
                  <div style={isMobile ? {...classes.right, width:'100%'} : classes.right}>
                    <div style={{height:'calc(100%)', overflowY:'scroll'}}>
                      {selectedItems.map(sel=><SelectedItemsCard
                                                refillAllItemsOnSelectedItemDelete={refillAllItemsOnSelectedItemDelete}
                                                itemCountMatch={itemCountMatch}
                                                setItemCountMatch={setItemCountMatch}
                                                existingProducts={existingProducts}
                                                selectedItems={selectedItems}
                                                setSelectedItems={setSelectedItems}
                                                key={sel.id}
                                                product={sel}
                                              />)}
                    </div>
                      <div style={classes.totalCont}>
                        <TotalCard
                          advance={bookData.advance}
                          discount={discount}
                          setDiscount={setDiscount}
                          setAmount={setAmount}
                          existingProducts={existingProducts}
                          numberofDays={bookData.billableDates.length}
                          selectedItems={selectedItems}
                        />
                      </div>
                  </div>
              </Container>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAddBookingClose} color="secondary">
              Cancel
            </Button>
            <Button disabled={!itemCountMatch || selectedItems.length === 0} autoFocus onClick={handleClick()} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
        <SnackBar message={snackMessage} open={showSnack} handleClose={()=>{setShowSnack(false)}} severity={snackType}/>
      </div>
    );
    }
    return null
}

